import { useState, useContext, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BackButton } from "../../components/BackButton";
import { Step } from "../../models/Step";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { thousandNumberSeperator } from "../../utils/format";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";

interface RepaymentOption 
{
  label: string;
  value: number;
}

const PeriodOfRepaymentOptions: RepaymentOption[] = [
  { label: '12 år', value: 144 },
  { label: '11 år', value: 132 },
  { label: '10 år', value: 120 },
  { label: '9 år', value: 108 },
  { label: '8 år', value: 96 },
  { label: '7 år', value: 84 },
  { label: '6 år', value: 72 },
  { label: '5 år', value: 60 },
  { label: '4 år', value: 48 },
  { label: '3 år', value: 36 },
  { label: '2 år', value: 24 }
];

const PeriodOfRepaymentStep: React.FunctionComponent = () => {
  const { amount } = useParams<{ amount: string }>();
  const amountNumber = amount ? parseFloat(amount) : null;

  const maxIntialVisibleOptions = 6;
  let [showAll, setShowAll] = useState(false);

  const [_, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();


  if (amountNumber === null || isNaN(amountNumber)) {
    navigate(`/`, { replace: true });
  }

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'PeriodOfRepayment' } });
    dispatch({ type: "set_step", step: Step.PeriodOfRepayment });
    scrollToTopOfContent();
  }, []);

  const handleClick = (months: number) => {
    dispatch({
      type: "set_periodOfRepaymentOption",
      values: months,
    });
    navigate(`/kunde`);
  };

  const changeAmount = useCallback(() => {
    navigate(`/`, { replace: true });
  }, [navigate]);

  return (
    <>
      <h2>Vælg din løbetid</h2>
      <h3>
        Dit valgte kreditbeløb:{" "}
        <span className="whitespace-nowrap font-semibold">
          {thousandNumberSeperator(amountNumber!)} kr.
        </span>{" "}
        <button className="text-regal-dark underline" onClick={changeAmount}>
          ændre beløb
        </button>
      </h3>

     
          <div className="mt-5">
            {PeriodOfRepaymentOptions.length === 0 && (
              <div className="text-center font-bold text-red-700 m-5">
                Vi kan desværre ikke tilbyde lån for dette kreditbeløb.
              </div>
            )}

            <div className="mt-5">
              {PeriodOfRepaymentOptions.length > 0 && (
                <div
                  className="w-1/2 md:w-1/3 p-2 text-center"
                  style={{ marginTop: "-30px" }}
                >
                  <div className="inline-block">
                    <div
                      className="relative text-sm md:text-base rounded px-1 inline-block text-white shadow-xl bg-blue-400"
                      style={{ top: "30px" }}
                    >
                      Mest populære
                    </div>
                  </div>
                </div>
              )}

              {PeriodOfRepaymentOptions.map((option, index) => (
                <div
                  className="w-full md:w-1/3 inline-block p-2"
                  key={option.value}
                >
                  {(showAll || index < maxIntialVisibleOptions) && (
                    <button
                      className="btn-choice"
                      onClick={() => handleClick(option.value)}
                    >
                      {option.value}
                      <span className="ml-1 text-xs font-light">mdr</span>
                    </button>
                  )}
                  {!showAll && index === maxIntialVisibleOptions && (
                    <button
                      className="btn-choice"
                      onClick={() => setShowAll(true)}
                      title="se resten"
                    >
                      Andet...
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="container-btn">
            <BackButton overridePage="/" />
          </div>
        </>
    
  );
};

export default PeriodOfRepaymentStep;
